import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.config.name), _mergeProps({
    ref: "form",
    mode: _ctx.mode,
    modelValue: _ctx._value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx._value) = $event))
  }, _ctx.config.props), null, 16, ["mode", "modelValue"]))
}